<template>
  <div>
    <el-dialog
      :visible.sync="showImportFile"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      title="导入名单"
    >
      <div class="import-container">
        <div v-show="importStatus == 0">
          <div>
            <div style="font-size: 12px; color: grey">导入文件</div>
            <el-upload
              ref="upload"
              class="upload"
              drag
              :auto-upload="false"
              :http-request="uploadToCos"
              :before-upload="beforeUpload"
              :on-change="addFile"
              action=""
              :on-remove="handleRemove"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload-text">点击或拖拽文件到此处</div>
              <div class="el-upload-text2">目前仅支持后缀为.xlsx的excel文件</div>
              <div class="el-upload__tip" slot="tip">
                <el-button
                  type="text"
                  style="color: #2f8fff; font-size: 12px"
                  @click="getImportExcel"
                >
                  下载导入模板
                </el-button>
              </div>
            </el-upload>
          </div>
        </div>
        <div v-show="importStatus === 1">
          <div class="import-tips">{{ importTips }}</div>
          <el-progress
            :text-inside="true"
            :stroke-width="24"
            :percentage="uploadPercentage"
          ></el-progress>
        </div>
        <div v-show="importStatus === 2">
          <div class="import-tips">
            <div
              style="display: flex; justify-content: center; font-size: 80px; margin-bottom: 20px"
            >
              <i class="el-icon-success" style="color: #76c84d" v-if="uploadRes.Status === 2"></i>
              <i class="el-icon-warning" style="color: #ffa600" v-if="uploadRes.Status === 3"></i>
            </div>
            <span v-if="uploadRes.Status === 2">{{ uploadRes.StatusMsg }}</span>
            <span v-if="uploadRes.Status === 3">{{ uploadRes.StatusMsg }}</span>
          </div>
          <!-- <div style="margin-top: 40px; text-align: center">
            <span v-if="uploadRes.Status === 2">已导入了 {{ uploadRes.Count }} 条数据</span>
            <span v-if="uploadRes.Status === 3">
              请点击
              <a :href="uploadRes.FileUrl">下载文件</a>
              ，查看错误数据
            </span>
          </div> -->
        </div>
      </div>
      <div style="text-align: right; margin-top: 20px">
        <el-button @click="close" size="small" v-show="importStatus !== 2">取消</el-button>
        <el-button type="primary" size="small" @click="importNext">
          {{ importNextTips }}
        </el-button>
      </div>
    </el-dialog>
<!--二次确认弹窗-->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      title="提示"
      :visible.sync="secondDialogVisible"
      width="300px"
      >
      <span>导入后无法撤回，请确认是否导入？</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="secondDialogVisible=false" size="small">取消</el-button>
        <el-button type="primary" @click="handleSubmit" size="small">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CosMixin } from '@/mixins/cos';
import { ExternalTransferImport } from '@/api/transferContacts';
import { getUploadSignApi } from '@/api/common';
import config from '@/config';
export default {
  name: 'ImportFile',
  filters: {
    handleTime(time) {
      if (time) {
        const date = new Date(time * 1000 + 8 * 3600 * 1000);
        return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '.');
      }
      return '-';
    },
  },
  mixins: [CosMixin],
  props: {
    showImportFile: {
      type: Boolean,
      default: false,
    },
    secondDialogVisible :{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      checkTypeFail: false,
      importStatus: 0, // 前端导入阶段 0 导入阶段 1导入中 2导入结束（成功/失败）
      fileUrl: '',
      suffix: '',
      flieUrl: '',
      uploadPercentage: 0,
      importTips: '名单上传中...',
      uploadRes: {
        Status: 3, // 后端导入状态，1导入中 2导入成功 3导入失败
        StatusMsg: '',
        // FileUrl: '',
        // Count: 0, // 成功导入数据的数量
      },
      templateUrl :'https://pfizer-1304685099.cos.ap-shanghai.myqcloud.com/TransferCustomerTemplate.xlsx', // 模版
    };
  },
  computed: {
    importNextTips() {
      // 导入成功 显示关闭
      if (this.importStatus === 2) {
        return '关闭';
      }
      return '确定';
    },
  },
  methods: {
    handleSubmit(){
      this.$refs.upload.submit();
      this.secondDialogVisible = false;
      this.importStatus += 1;
    },
    importNext() {
      switch (this.importStatus) {
        case 0:
          if (this.$refs.upload.uploadFiles.length === 0) {
            this.$message.warning('请选择导入文件');
            return;
          }
          this.secondDialogVisible = true;
          return;
          break;
        case 2:
          this.close();
          break;
      }
      if (this.checkTypeFail) {
        return;
      }
      this.importStatus += 1;
    },
    resetImportStatus() {
      this.secondDialogVisible = false;
      // 清空导入进度，300为dialog渐出的时间
      setTimeout(() => {
        this.$refs.upload.clearFiles();
        Object.assign(this.$data, this.$options.data());
      }, 300);
    },
    close() {
      this.$emit('close');
    },

    addFile(file, fileList) {
      // console.log(file);
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    beforeUpload(file) {
      // 上传前判断格式
      if (!/.xlsx$/gi.test(file.name)) {
        this.checkTypeFail = true;
        this.$message.warning('请选择格式正确的文件');
        return false;
      }
      this.checkTypeFail = false;
      this.suffix = `.${file.name.split('.')[1]}`;
      return true;
    },
    handleRemove() {
      this.flieUrl = '';
    },
    getImportExcel() {
      this.g_tourl(this.templateUrl, { open: true });
    },
    uploadToCos(file) {
      // 文件上传至腾讯云cos
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }

      this.putCosObject(
        {
          imgCosKey: `${file.file.uid}${rs}`,
          fileObject: file.file,
        },
        undefined,
        (progressData) => {
          console.log(progressData);
          this.uploadPercentage = progressData.percent * 50;
        },
        async () => {
          const res = await getUploadSignApi({
            app_id: config.cosAppId,
            credentials: 1,
            suffix: this.suffix,
          });
          const { sessionToken, tmpSecretId, tmpSecretKey } = res?.data?.credentials || {};
          const {
            cdn_url: cdnUrl,
            key,
            startTime,
            expiredTime,
            Region: region,
            Bucket: bucket,
          } = res?.data || {};
          return {
            tmpSecretId,
            tmpSecretKey,
            sessionToken,
            cdnUrl,
            key,
            startTime,
            expiredTime,
            region,
            bucket,
          };
        },
      )
        .then((res) => {
          this.fileUrl = res.data;
          this.importTips = '名单导入中...';
          this.upLoadToBackEnd();
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    upLoadToBackEnd() {
      ExternalTransferImport({
        url: this.fileUrl,
      })
        .then((res) => {
          const { err_code, err_msg } = res;
          this.uploadPercentage = 100;
          // eslint-disable-next-line camelcase
          if (err_code === 0) {
            this.uploadRes = {
              StatusMsg: '导入成功',
              Status: 2,
            };
          } else {
            this.uploadRes = {
              // eslint-disable-next-line camelcase
              StatusMsg: `导入失败: ${err_msg}`,
              Status: 3,
            };
          }
          setTimeout(() => {
            this.importStatus = 2;
          }, 300);
        })
        .catch((e) => {
          this.uploadPercentage = 100;
          this.uploadRes = {
            StatusMsg: `发生错误：${e.message}`,
            Status: 3,
          };
          setTimeout(() => {
            this.importStatus = 2;
          }, 300);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.el-upload-text {
  font-size: 14px;
  font-weight: bold;
  color: black;
}
.el-upload-text2 {
  margin-top: 20px;
  font-size: 14px;
  font-weight: normal;
  color: grey;
}
.el-upload__tip {
  text-align: left;
  font-size: 14px;
}

.el-dialog__header {
  border-bottom: 1px solid black;
}

.form {
  ::v-deep.el-form-item {
    .el-form-item__label {
      font-size: 16px;
      color: #303133;
    }
  }
}
.table {
  font-size: 16px;
  thead {
    color: #313233;
  }
}
.import-container {
  height: 240px;
  margin: 20px 0;
}
.import-tips {
  padding-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 30px;
}
::v-deep.upload {
  text-align: center;
  .el-upload {
    .el-upload-dragger {
      width: 450px;
      height: 165px;
    }
  }
  .el-upload-list__item-name {
    padding: 0;
    margin: 0;
  }
}
// 表格鼠标文字编辑悬浮
.edit_able {
  position: relative;
  cursor: pointer;
  padding-right: 10px;
  &:hover {
    // text-decoration: underline;
    // color: #5fa4e8;
    &:after {
      position: absolute;
      //   content: '🖋🖊🖌🖍';
      content: '🖊';
      display: inline-block;
      font-size: 20px;
      padding-left: 5px;
      text-decoration: underline;
    }
  }
}
</style>
